const dateFormat = (fecha) => {
    const dateSF = fecha?.split(' ')[0]?.split('-')
    const meses = ['enero', 'febrero', 'marzo', 'abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
    let fechaForma
    if(fecha){
        fechaForma = `${dateSF[2]} ${ meses[ Number(dateSF[1]) - 1] } ${dateSF[0]}`
    }
    return fechaForma
}

export default dateFormat